import React from 'react';
import NumberFormat from 'react-number-format';

import SliderQuestion from './components/SliderQuestion';
import ShareCard from './components/ShareCard';

class Calc extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bedCount: parseInt(this.props.bedCount),
      padsPerWeek: parseInt(this.props.padsPerWeek),
      costPerPad: parseInt(this.props.costPerPad),
      hourlyStaffCost: parseInt(this.props.hourlyStaffCost),
      minutesSaved: parseInt(this.props.minutesSaved),
      currency: this.props.currency || 'USD',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    // https://www.pluralsight.com/guides/handling-multiple-inputs-with-single-onchange-handler-react
    let value = parseInt(event.target.value, 10) || 0;
    console.log(value);
    this.setState({ [event.target.name]: value });
  }

  calculateNursingTimeSavings() {
    return this.state.bedCount * (this.state.minutesSaved / 60);
  }

  calculateNursingSavings() {
    return this.calculateNursingTimeSavings() * this.state.hourlyStaffCost;
  }

  currencyPrefix() {
    return this.state.currency === 'GBP' ? '£' : '$'
  }

  calculatePadSavings() {
    // TODO : Verify the UK price
    const stealthCost = this.state.currency === 'GBP' ? 225 : 175;
    const stealthLife = 548

    const stealthCostPerDay = stealthCost / stealthLife;
    const disposableCostPerDay = (this.state.costPerPad * this.state.padsPerWeek) / 7;

    return (disposableCostPerDay - stealthCostPerDay) * this.state.bedCount;
  }

  render() {
    let shareUrl = `${window.location.href.split('?')[0]}?b=${this.state.bedCount}&w=${this.state.padsPerWeek}&c=${this.state.costPerPad}&s=${this.state.hourlyStaffCost}&m=${this.state.minutesSaved}`;

    return (
      <div className="md:flex flex-row">
        <div className="flex-1 p-6">
          <SliderQuestion
            prompt="Number of patients using disposable pads:"
            name="bedCount"
            value={this.state.bedCount}
            max={100}
            min={1}
            units="beds"
            onChange={bedCount => this.setState({ bedCount })} />

          <SliderQuestion
            prompt="Cost per disposable bed pad:"
            name="costPerPad"
            value={this.state.costPerPad}
            max={100}
            min={5}
            onChange={costPerPad => this.setState({ costPerPad })}
            currency={this.state.currency}
            onCurrencyChange={currency => this.setState({ currency })} />
          <SliderQuestion
            prompt="Number of disposable pads used per bed each week:"
            name="padsPerWeek"
            value={this.state.padsPerWeek}
            max={10}
            min={1}
            units="pads"
            onChange={padsPerWeek => this.setState({ padsPerWeek })} />

          <SliderQuestion
            prompt="Hourly cost for staff:"
            name="hourlyStaffCost"
            value={this.state.hourlyStaffCost}
            max={85}
            min={10}
            onChange={hourlyStaffCost => this.setState({ hourlyStaffCost })}
            currency={this.state.currency}
            onCurrencyChange={currency => this.setState({ currency })} />

          <SliderQuestion
            prompt="Number of staff minutes saved per day per bed:"
            name="minutesSaved"
            value={this.state.minutesSaved}
            max={120}
            min={10}
            units="minutes"
            onChange={minutesSaved => this.setState({ minutesSaved })} />
        </div>

        <div className="flex flex-col flex-1 p-6 bg-purple-50 space-y-0.5">
          <div className="flex-1 sm:px-16 md:px-8">
            {/* ANNUAL SAVINGS  */}
            <h2 className="font-raleway text-xl font-semibold pb-2">Annual Savings</h2>

            <div className="flex flex-row">
              <div className="flex-grow text-md">Nursing Time Saved:</div>
              ~<NumberFormat
                className="font-medium mb-2 mr-1"
                value={(this.calculateNursingTimeSavings() * 365)}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={0} /> hours
            </div>

            <div className="flex flex-row">
              <div className="flex-grow text-md">Nursing Time Savings:</div>
              <NumberFormat
                className="font-medium"
                value={this.calculateNursingSavings() * 365}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={0}
                prefix={this.currencyPrefix() + ' '} />
            </div>

            <div className="flex flex-row">
              <div className="flex-grow">Pad Savings:</div>
              <NumberFormat
                className="font-medium"
                value={this.calculatePadSavings() * 365}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={0}
                prefix={this.currencyPrefix() + ' '} />
            </div>

            <div className="flex flex-row">
              <div className="flex-grow font-semibold">Total Annual Savings:</div>
              <NumberFormat
                className="font-semibold"
                value={(this.calculateNursingSavings() + this.calculatePadSavings()) * 365}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={0}
                prefix={this.currencyPrefix() + ' '} />
            </div>

            {/* DAILY SAVINGS  */}
            <h2 className="font-raleway text-xl font-semibold pt-12 pb-2">Daily Savings</h2>

            <div className="flex flex-row">
              <div className="flex-grow text-md">Nursing Time Saved:</div>
              ~<NumberFormat
                className="font-medium mb-2 mr-1"
                value={this.calculateNursingTimeSavings()}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={1} /> hours
            </div>

            <div className="flex flex-row">
              <div className="flex-grow text-md">Nursing Time Savings:</div>
              <NumberFormat
                className="font-medium"
                value={this.calculateNursingSavings()}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2}
                prefix={this.currencyPrefix() + ' '} />
            </div>

            <div className="flex flex-row">
              <div className="flex-grow">Pad Savings:</div>
              <NumberFormat
                className="font-medium"
                value={this.calculatePadSavings()}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2}
                prefix={this.currencyPrefix() + ' '} />
            </div>

            <div className="flex flex-row">
              <div className="flex-grow font-semibold">Total Daily Savings:</div>
              <NumberFormat
                className="font-semibold"
                value={(this.calculateNursingSavings() + this.calculatePadSavings())}
                displayType={'text'}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2}
                prefix={this.currencyPrefix() + ' '} />
            </div>
          </div>
          <div className="flex pt-12 justify-end">
            <ShareCard
              url={shareUrl}/>
          </div>
          <ul className="text-sm list-disc mx-8 pt-4">
              <li>
                Additional savings may be realized in reduced pad disposal and logistics costs.
              </li>
            </ul>
        </div>
      </div>
    );
  }
}

// TODO: Encoded URL
// /?b=10&w=10&c=10&s=15&m=10
// /?i=10-10-10-15-10

export default Calc;
